// assets/oxia-hide-express-checkout.js
(() => {
  console.log('[OXIA] hide express checkout loaded', new Date().toISOString());

  const H2_TEXT = 'かんたん決済';

  const hideBlock = (el) => {
    if (!el) return false;
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('data-oxia-hidden', '1');
    return true;
  };

  const hide = () => {
    let hit = false;

    // ① 安定IDから親を消す
    const wallets = document.querySelector('#express-checkout-wallets-wrapper');
    if (wallets) {
      const block =
        wallets.closest('[data-count]') ||
        wallets.closest('.kTI19') ||
        wallets.closest('section,div') ||
        wallets.parentElement;
      if (block) hit = hideBlock(block) || hit;
    }

    // ② 「かんたん決済」という見出しから親ブロックを消す（取り逃し防止）
    const h2s = Array.from(document.querySelectorAll('h2'));
    const targetH2 = h2s.find(h => (h.textContent || '').trim() === H2_TEXT);
    if (targetH2) {
      const block =
        targetH2.closest('[data-count]') ||
        targetH2.closest('section') ||
        targetH2.closest('div');
      if (block) hit = hideBlock(block) || hit;
    }

    // ③ 「その他のオプションを表示する」ボタンの親も消す（露出残り防止）
    const moreBtn = Array.from(document.querySelectorAll('button'))
      .find(b => (b.textContent || '').includes('その他のオプションを表示する'));
    if (moreBtn) {
      const block =
        moreBtn.closest('[data-count]') ||
        moreBtn.closest('section') ||
        moreBtn.closest('div');
      if (block) hit = hideBlock(block) || hit;
    }

    return hit;
  };

  // 初回と、少し遅延してもう一回（初回レンダリング順のズレ対策）
  hide();
  setTimeout(hide, 50);
  setTimeout(hide, 300);
  setTimeout(hide, 1000);

  // DOM差し替え対策：監視
  const obs = new MutationObserver(() => {
    hide();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();